export default __webpack_public_path__ + "static/media/Logo.65de8fb4.svg";